module.exports = __webpack_public_path__ + "static/media/go-cleaner.d5b94010.webp";